import React from 'react';

import styles from './connect-account.module.css';
import sharedStyles from '../../sharedStyles.module.css';
import Message from '../Message';
import { useFetchRequestAccessForm } from '../../api/hooks/useFetchRequestAccessForm';
import { RequestAccessForm } from '../../api/types';
import { MainContentContainer } from '../main-content-container';

const ConnectAccountBody = () => {
    const { data } = useFetchRequestAccessForm() as { data: RequestAccessForm };

    return (
        <MainContentContainer className={styles.content}>
            {data?.logoUrl && (
                <img src={data?.logoUrl} alt="Company Logo" className={styles.logoImage} />
            )}
            <div className={styles.text}>
                <h1 className={sharedStyles.textHeadline}>{data.companyName}</h1>
                <Message code="app.request.access.public.landingpage.subheader" />
                <div className={styles.requestInfo}>
                    <span>
                        <Message
                            className={sharedStyles.textBold}
                            code="app.request.access.public.step.1.requestedBy"
                        />{' '}
                        {data.directoryUserAccountEmail}
                    </span>
                    <span>
                        <Message
                            className={sharedStyles.textBold}
                            code="app.request.access.public.step.1.accessLevel"
                        />{' '}
                        <Message code={`app.request.access.public.access.level.${data?.accessType.toLowerCase()}`} />
                    </span>
                </div>
            </div>
        </MainContentContainer>
    );
};

export default ConnectAccountBody;
